export class SearchOption {
  constructor(public value: number, public label: string, public searchDimension?: string) {}
}
